import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StateMasterService } from 'src/Services/state-master.service';
import { CheckAuth } from 'src/Services/utility.service';
import { StateMasterModel } from 'src/Models/stateMasterModel';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { ToolEnum } from 'src/Models/Common';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-states',
  templateUrl: './states.component.html',
  styleUrls: ['./states.component.css']
})
export class IPCSStatesComponent implements OnInit {
  stateCode: any;
  tokenKey: string;
  listofState: StateMasterModel[];
  listofStateExport: StateMasterModel[];

  PageNumber: number = 1;
  PageSize: number;
  WhereCondition: string;
  OrderBy: string;
  StateName: string;

  upDowNameCSS: string = '';
  upDowShortNameCSS: string = '';
  upDowActiveCSS: string = '';
  upDowSortCSS: string = '';
  isAscending: boolean = false;
  isRecord: boolean = false;
  isloading: boolean = false;
  SelectedTool: string;
  productId: number = 1;
  totalRecordCount: number = 0;
  stateId: number = 0;
  openMenuIndex: number = -1;

  selectedItem: any;
  previousStatus: boolean = false;
  statusState: boolean = false; // already using

  moduleList: any[] = [{ itemName: 'Yes', id: '1' }, { itemName: 'No', id: '0' }];
  selectedItemsStatus: any[] = [{ itemName: 'Yes', id: '1' }];
  dropdownSettingsStatus = {};
  statusId: number = 1;

  constructor(private readonly router: Router,
    private readonly state: StateMasterService,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.listofState = [];
    this.PageNumber = 1;
    this.PageSize = 999;
    this.WhereCondition = 'null';
    this.OrderBy = 'SortOrder';
    this.StateName = 'null';
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.productId = ToolEnum[this.SelectedTool];
    this.titleService.setTitle('Jurisdictions');
    this.PageSize = 1000;

    this.dropdownSettingsStatus = {
      singleSelection: true,
      text: "Filter by Active",
      enableSearchFilter: false,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No record available',
      showCheckbox: false
    };
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.GetState();
  }

  pageChanged($event: any) {
    this.PageNumber = parseInt($event.page);
    this.GetState();
  }

  GetState() {
    this.state.GetStateMasterFindByPagedV2(this.tokenKey, this.PageNumber, this.PageSize, this.WhereCondition, this.OrderBy, this.StateName, this.productId,this.statusId,false).subscribe(
      data => {
        this.isloading = false;
        this.listofState = data['state'];
        if (this.listofState != null) {
          if (this.listofState.length == 0)
            this.isRecord = true;
          else
            this.isRecord = false;
        }
        else
          this.isRecord = true;
      },
      error => { this.stateCode = error }
    );
  }

  redirecttostatematrix(stateid) {
    let navigation = '/admin/' + this.SelectedTool + '/state/setup/manage/' + stateid;
    this.router.navigate([navigation]);
  }

  redirectToStatePreview(stateid) {
    sessionStorage.setItem('StateSetupManageRedirection', stateid);
    sessionStorage.setItem('isAdminOpen', 'true');
    sessionStorage.setItem('isClickOnState', 'true');
    let navigation = '/admin/' + this.SelectedTool + '/state/matrix/preview/';
    this.router.navigate([navigation]);
  }

  keywordFilters($event) {
    this.PageNumber = 1;
    if ($event.target.value != "" && $event.target.value != null)
      this.StateName = $event.target.value;
    else
      this.StateName = 'null';

    this.GetState();
  }

  sort(sortBy: string) {
    if (!this.isAscending) {
      this.isAscending = true;
      this.OrderBy = sortBy + ' DESC';

      if (sortBy === "Name") {
        this.upDowNameCSS = 'fa fa-arrow-down';
        this.upDowShortNameCSS = '';
        this.upDowSortCSS = '';
        this.upDowActiveCSS = '';
      }
      else if (sortBy === "ShortName") {
        this.upDowNameCSS = '';
        this.upDowShortNameCSS = 'fa fa-arrow-down';
        this.upDowSortCSS = '';
        this.upDowActiveCSS = '';
      }
      else if (sortBy === "sortOrder") {
        this.upDowNameCSS = '';
        this.upDowShortNameCSS = '';
        this.upDowSortCSS = 'fa fa-arrow-down';
        this.upDowActiveCSS = '';
      }
      else if (sortBy === "IsActive") {
        this.upDowNameCSS = '';
        this.upDowShortNameCSS = '';
        this.upDowSortCSS = '';
        this.upDowActiveCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.OrderBy = sortBy;

      if (sortBy === "Name") {
        this.upDowNameCSS = 'fa fa-arrow-up';
        this.upDowShortNameCSS = '';
        this.upDowSortCSS = '';
        this.upDowActiveCSS = '';
      }
      else if (sortBy === "ShortName") {
        this.upDowNameCSS = '';
        this.upDowShortNameCSS = 'fa fa-arrow-up';
        this.upDowSortCSS = '';
        this.upDowActiveCSS = '';
      }
      else if (sortBy === "sortOrder") {
        this.upDowNameCSS = '';
        this.upDowShortNameCSS = '';
        this.upDowSortCSS = 'fa fa-arrow-up';
        this.upDowActiveCSS = '';
      }
      else if (sortBy === "IsActive") {
        this.upDowNameCSS = '';
        this.upDowShortNameCSS = '';
        this.upDowSortCSS = '';
        this.upDowActiveCSS = 'fa fa-arrow-up';
      }
    }
    this.PageNumber = 1;
    this.GetState();
  }

  addState() {
    let navigation = '/admin/' + this.SelectedTool + '/states/manage';
    this.router.navigate([navigation]);
  }

  updateState(stateId) {
    let navigation = '/admin/' + this.SelectedTool + '/states/manage/' + stateId;
    this.router.navigate([navigation]);
  }

  setDeleteData(id) {
    this.stateId = id;
  }

  deleteState(stateId) {
    this.isloading = true;
    this.state.DeleteState(this.tokenKey, stateId).subscribe(
      data => {
        this.isloading = false;
        if (data['status'] == 'Success') {
          if (data['message'] != "")
            this.showMessage(data['message'], 'Warning', 'warning')
          else
            this.showMessage("Deleted successfully", 'Success', 'success')
        }
        this.GetState();
      },
      error => { this.stateCode = error }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
    else if (msgType == 'warning') {
      setTimeout(() => this.toastr.warning(msg, msgTitle));
    }
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index; // Toggle the menu
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportIPCSState() {
    this.isloading = true;
    this.listofStateExport=[];
    this.state.GetStateMasterFindByPagedV2(this.tokenKey, this.PageNumber, this.PageSize, this.WhereCondition, this.OrderBy, this.StateName, this.productId,this.statusId, true).subscribe(
      data => {
        this.listofStateExport = data['state'];
        if (this.listofStateExport != null) {
          if (this.listofStateExport.length > 0) {
            setTimeout(() => {
              this.DownloadIPCSState();
              this.isloading = false;
            }, 2000);
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
        else {
          this.isloading = false;
          this.toastr.error("No record found", "Error");
        }
      },
      error => {
        this.isloading = false;
        this.stateCode = error
      }
    );
  }

  DownloadIPCSState() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportIPCSJurisdictions';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportIPCSJurisdictions.xls");
  }

  
  onIsActiveCheckboxChange(event: any, item: any) {
    this.selectedItem = item;
    this.previousStatus = !event.target.checked; // store old value
    this.statusState = event.target.checked;
    this.stateId = item.stateId;

    // open modal
    document.getElementById("btnopenStatuspopup").click();
  }


  updateStatus() {
    this.isloading = true;

    this.selectedItem.isActive = this.statusState;

    let value = {
      ProductId: this.productId,
      StateID: this.stateId,
      StatusFlag: this.statusState
    }
    this.state.stateStatusUpdate(this.tokenKey, value).subscribe(
      result => {
        this.isloading = false;
        if (result['status'] == 'Success') {
          if (this.statusState)
            this.showMessage("State Status Active Updated successfully", 'Success', 'success')
          else
            this.showMessage("State Status InActive Updated successfully", 'Success', 'success')
        }
        else {
          this.showMessage("State Status Updated Fail", 'Error', 'error');
        }

        this.GetState();
      },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  updateStatusNo() {
    if (this.selectedItem) {
      this.selectedItem.isActive = this.previousStatus;
    }
  }

  onSelectStatus($event: any) {
    this.statusId = $event.id;
    this.PageNumber = 1;
    this.GetState();
  }

  onDeSelectStatus($event: any) {
    this.statusId = 3;
    this.PageNumber = 1;
    this.GetState();
  }
}
